import {
    Box,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Button,
    Flex,
    Heading,
    Spacer,
    Text
} from "@chakra-ui/react";
import React from "react";
import { Content, ContentContainer, Header } from "./styles";
import Navbar from "../../components/Navbar";

import Sidenav from "../../components/Sidenav";
import { useDashboardTitle } from "../../hooks/useDashboardTitle";
import { useGlobalContext } from "../../hooks/useGlobalContext";
import { IncomingCallAnswerModal } from "../../pages/Call";


interface IDashboardLayoutProps {
  title?: string;
}

const DashboardLayout: React.FC<IDashboardLayoutProps> = ({
    children,
    title: staticTitle
}) => {
    const { title } = useDashboardTitle();

    return (
        <Box width="100%" height="calc(100vh - 0px)" position="relative">
            { /* <IncomingCallAnswerModal /> */ }
            <Sidenav />
            <ContentContainer>
                <Navbar />
                <Box>
                    <Header>
                        <Text>{ staticTitle || title }</Text>
                    </Header>
                </Box>
                { /* <Flex bg="white" p={1}>
          <Box p="2">
            <Heading size="md">{title}</Heading>
          </Box>
          <Spacer />
          <Box>
            <Button colorScheme="teal" mr="4">
              Sign Up
            </Button>
            <Button colorScheme="teal">Log in</Button>
          </Box>
        </Flex> */ }
                <Content>{ children }</Content>
            </ContentContainer>
        </Box>
    );
};

export default DashboardLayout;
